import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useConfig } from "../../config/ConfigContext";
import { getSubdomain } from "../../config/configUtils";
import { SPECIAL_PRODUCT_ID_B5D, SUBDOMAIN_B5D } from "../../constants";
import { getMeals } from "../../utils/getMealsFromN8n";

const MealsContext = createContext();

function applyB5dCartRule(nextCart, meals) {
  const subdomain = getSubdomain();
  let cart = [...nextCart];

  if (subdomain === SUBDOMAIN_B5D) {
    const specialProductIndex = cart.findIndex(
      (item) => item.meal.id === SPECIAL_PRODUCT_ID_B5D
    );
    const specialProduct = meals.find((m) => m.id === SPECIAL_PRODUCT_ID_B5D);

    if (cart.length > 0 && specialProductIndex === -1 && specialProduct) {
      cart.push({ meal: specialProduct, quantity: 1 });
    } else if (cart.length === 1 && specialProductIndex !== -1) {
      cart = [];
    }
  }

  cart.sort((a, b) => {
    const indexA = meals.findIndex((m) => m.id === a.meal.id);
    const indexB = meals.findIndex((m) => m.id === b.meal.id);
    return indexA - indexB;
  });

  return cart;
}

export const MealsProvider = ({ children }) => {
  const config = useConfig();
  const [meals, setMeals] = useState([]);
  const [cart, setCartInternal] = useState([]);

  useEffect(() => {
    if (!config) return;
    getMeals(config).then(setMeals).catch(console.error);
  }, [config]);

  const setCart = useCallback(
    (updater) => {
      setCartInternal((prev) => {
        const next =
          typeof updater === "function" ? updater(prev) : updater;
        return applyB5dCartRule(next, meals);
      });
    },
    [meals]
  );

  const categorizedCart = useMemo(() => {
    const categoryMapping = {
      Food: [
        "Breakfast - 2 pax",
        "Starters - 2 pax",
        "Sandwiches - 2 pax",
        "Caviar",
        "Snack Trays - 2 pax",
        "Main Courses - Individual",
        "Desserts - To share",
        "Desserts - Individual",
      ],
      Packages: ["Package"],
      Drink: [
        "Soft Drinks",
        "Water",
        "Fruit Juice",
        "Wine - Rose",
        "Wine - White",
        "Wine - Red",
        "Champagne - Brut",
        "Champagne - Rose",
        "Champagne - Blanc de Blancs",
        "Beers",
        "Liquor",
        "Tequila",
        "Vodka",
        "Rhum",
        "Gin",
        "Whisky",
        "Cognac",
      ],
    };
    const categories = { Food: [], Packages: [], Drink: [] };

    cart.forEach((item) => {
      const category = item.meal.fields["Catégorie"];
      if (categoryMapping.Food.includes(category)) {
        categories.Food.push(item);
      } else if (categoryMapping.Packages.includes(category)) {
        categories.Packages.push(item);
      } else if (categoryMapping.Drink.includes(category)) {
        categories.Drink.push(item);
      }
    });

    return categories;
  }, [cart]);

  return (
    <MealsContext.Provider
      value={{
        meals,
        setMeals,
        cart,
        setCart,
        categorizedCart,
      }}
    >
      {children}
    </MealsContext.Provider>
  );
};

export const useMeals = () => useContext(MealsContext);
